// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_OpcoesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/report_attributes/opcoes/{attribute_id}
 *
 * Returns the active options for the given report attribute. Legacy
 * `dados` shape is a list, so getDados() returns the array directly.
 */
import type { Report_attributes_OpcaoRow } from './Report_attributes_OpcaoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Report_attributes_OpcoesResponseDados = Report_attributes_OpcaoRow[];

export type Report_attributes_OpcoesResponse = ApiResponse<Report_attributes_OpcoesResponseDados>;

registerResponseContract('Report_attributes_OpcoesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_rao_id:            { type: 'number',  required: true },
      so_rao_attribute_id:  { type: 'number',  required: true },
      so_rao_value:         { type: 'string',  required: true },
      so_rao_display_order: { type: 'number',  required: true },
      so_rao_active:        { type: 'number',  required: true },
      so_rao_created_at:    { type: 'string',  required: true },
    },
  },
})
